// Habilidades do agente em linguagem de cliente. Os nomes sao os do motor; os grupos sao nossos.
export const GRUPOS_NATIVOS = [
  {
    chave: 'CONVERSA',
    ferramentas: [
      'private_note',
      'set_labels',
      'set_custom_attribute',
      'resolve_conversation',
      'react_to_message',
      'handoff_to_human',
      'skip_reply',
    ],
  },
  { chave: 'VENDAS', ferramentas: ['kanban_move_card', 'update_kanban_task'] },
  {
    chave: 'AVANCADO',
    ferramentas: ['send_image', 'set_voice_preference'],
  },
];

// Ferramentas do nosso MCP interno, agrupadas pelo prefixo da capacidade.
export const GRUPOS_MCP = [
  { chave: 'AGENDA', prefixo: 'appointments_' },
  { chave: 'CLIENTES', prefixo: 'contacts_' },
  { chave: 'FUNIL', prefixo: 'kanban_' },
  { chave: 'CONVERSAS', prefixo: 'conversations_' },
  { chave: 'ROTINAS', prefixo: 'routines_' },
];

// Sempre ligadas: sem elas o agente promete passar para a equipe e nao passa, ou nao consegue ficar calado.
// O backend (Plano::NATIVAS_OBRIGATORIAS) garante o mesmo.
export const NATIVAS_OBRIGATORIAS = ['handoff_to_human', 'skip_reply'];

export const travada = (ferramenta, plano) =>
  !(plano?.ferramentas_nativas || []).includes(ferramenta);

const FERRAMENTAS_DE_FUNIL = ['kanban_move_card', 'update_kanban_task'];

// Chave de i18n do motivo da trava: o funil pode estar com o Operador ou desmarcado na montagem,
// e isso nao tem nada a ver com o plano.
export const motivoDaTrava = (ferramenta, plano) => {
  if (NATIVAS_OBRIGATORIAS.includes(ferramenta)) {
    return 'AGENTE_IA.HABILIDADES.SEMPRE_LIGADA';
  }
  if (!travada(ferramenta, plano)) return null;
  if (FERRAMENTAS_DE_FUNIL.includes(ferramenta) && plano?.motivo_sem_funil) {
    return `AGENTE_IA.HABILIDADES.SEM_FUNIL.${plano.motivo_sem_funil.toUpperCase()}`;
  }
  return 'AGENTE_IA.DISPONIVEL_NO_AVANCADO';
};

export const nativasLigadas = grants => [
  ...new Set([
    ...(grants.find(grant => grant.source === 'NATIVE')?.enabledTools || []),
    ...NATIVAS_OBRIGATORIAS,
  ]),
];

export const alternarNativa = (grants, ferramenta, ligar) => {
  const atuais = nativasLigadas(grants);
  const enabledTools = ligar
    ? [...new Set([...atuais, ferramenta])]
    : atuais.filter(nome => nome !== ferramenta);
  const outros = grants.filter(grant => grant.source !== 'NATIVE');
  return [{ source: 'NATIVE', enabledTools }, ...outros];
};

export const ferramentasDoGrupo = (todas, prefixo) =>
  todas.filter(nome => nome.startsWith(prefixo));

const grantInterno = (grants, conexaoId) =>
  grants.find(
    grant =>
      grant.source === 'MCP' &&
      String(grant.mcpServerConnectionId) === String(conexaoId)
  );

export const grupoMcpLigado = (grants, conexaoId, nomes) => {
  const ligadas = grantInterno(grants, conexaoId)?.enabledTools || [];
  return nomes.length > 0 && nomes.every(nome => ligadas.includes(nome));
};

export const alternarGrupoMcp = (grants, conexaoId, nomes, ligar) => {
  const atuais = grantInterno(grants, conexaoId)?.enabledTools || [];
  const enabledTools = ligar
    ? [...new Set([...atuais, ...nomes])]
    : atuais.filter(nome => !nomes.includes(nome));
  const outros = grants.filter(
    grant => grant !== grantInterno(grants, conexaoId)
  );
  return [
    ...outros,
    { source: 'MCP', mcpServerConnectionId: conexaoId, enabledTools },
  ];
};

// Integracoes de fora do Atende (API da empresa, pacotes, documentos, codigo e MCP de terceiros). O nosso MCP
// interno e a base de conhecimento nao contam.
const FONTES_DE_INTEGRACAO = ['HTTP', 'INTEGRATION', 'DOCUMENT', 'CODE', 'MCP'];

export const integracoesDe = (grants, conexaoId) =>
  grants.filter(
    grant =>
      FONTES_DE_INTEGRACAO.includes(grant.source) &&
      !(
        grant.source === 'MCP' &&
        String(grant.mcpServerConnectionId) === String(conexaoId)
      )
  );

// Desligar tira as integracoes da persona; religar (antes de salvar) devolve as que ela tinha.
export const alternarIntegracoes = (grants, conexaoId, guardadas, ligar) => {
  const externas = integracoesDe(grants, conexaoId);
  const outras = grants.filter(grant => !externas.includes(grant));
  return ligar ? [...outras, ...guardadas] : outras;
};

// Nome de cliente para cada ferramenta que o agente leu: as nativas pelo nome da tela "O que ele pode fazer",
// as do nosso MCP pelo grupo (agenda, clientes...) e o resto (API da empresa, MCP de terceiros) como integracao.
// Devolve chaves de i18n, sem repetir.
// Nativas que todo plano liga sem opcao na tela (nao sao integracao de fora).
const NATIVAS_DE_APOIO = {
  get_current_time: 'AGENTE_IA.PROMPT.FERRAMENTAS.DATA_HORA',
};

export const chavesDasFerramentas = nomes => {
  const nativas = GRUPOS_NATIVOS.flatMap(grupo => grupo.ferramentas);
  const chaves = nomes.map(nome => {
    if (nativas.includes(nome)) return `AGENTE_IA.HABILIDADES.NATIVAS.${nome}`;
    if (NATIVAS_DE_APOIO[nome]) return NATIVAS_DE_APOIO[nome];
    const grupo = GRUPOS_MCP.find(item => nome.startsWith(item.prefixo));
    if (grupo) return `AGENTE_IA.HABILIDADES.MCP.${grupo.chave}.TITULO`;
    return 'AGENTE_IA.PROMPT.FERRAMENTAS.INTEGRACAO';
  });
  return [...new Set(chaves)];
};
